// src/pages/Workers/Absences/ExportAbsencesExcel.js
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import i18n from "../../../i18n";
// Same format you use inside your table
const formatDate = (d) => {
  if (!d) return "—";
  const date = new Date(d);
  return date
    .toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    })
    .replace(" ", " ")
    .replace(",", ",");
};

const ExportAbsencesExcel = async (data) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Absences Report");
const t = i18n.t.bind(i18n);
   worksheet.columns = [
    { header: t("absence.id"), key: "id", width: 10 },
    { header: t("absence.worker"), key: "worker", width: 25 },
    { header: t("absence.department"), key: "department", width: 20 },
    { header: t("absence.type"), key: "type", width: 20 },
    { header: t("absence.start_date"), key: "startDate", width: 18 },
    { header: t("absence.end_date"), key: "endDate", width: 18 },
    { header: t("absence.source"), key: "source", width: 20 },
    { header: t("absence.comments"), key: "comment", width: 40 },
  ];


  // Convert to row format + formatted dates
  const formattedRows = data.map((item) => ({
    id: item.id,
    worker: item.worker?.name || "—",
    department: item.worker?.department || "—",
    type: item.absence?.type?.name || "—",
    startDate: formatDate(item.absence?.startDate),
    endDate: formatDate(item.absence?.endDate),
    source: item.absence?.source || "—",
    comment: item.absence?.comment || "—",
  }));

  worksheet.addRows(formattedRows);

  // Style header
  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "003149" },
    };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });

  // Generate & Download
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(
    blob,
    `Absences_Report_${new Date().toISOString().slice(0, 10)}.xlsx`
  );
};

export default ExportAbsencesExcel;
